import { render } from "./hrm-team-requests.vue?vue&type=template&id=155cbf0c&scoped=true"
import script from "./hrm-team-requests.vue?vue&type=script&lang=js"
export * from "./hrm-team-requests.vue?vue&type=script&lang=js"

import "./hrm-team-requests.vue?vue&type=style&index=0&id=155cbf0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155cbf0c"]])

export default __exports__